import { Injectable } from "@angular/core";
import { Messaging, getToken, onMessage } from "@angular/fire/messaging";
import { Store } from "@ngrx/store";
import { MessageService } from "primeng/api";
import { selectLoggedIn } from "src/app/core/stores";
import { environment } from "src/environments/environment";
import { NotificationCounter } from "../../helpers/notification-counter";
import { PushNotificationAPIService } from "./api/push-notification-api.service";

@Injectable({
    providedIn: "root",
})
export class PushNotificationService {
    initiated: boolean = false;

    constructor(
        private readonly _messaging: Messaging,
        private messageService: MessageService,
        private pushNotificationAPIService: PushNotificationAPIService,
        private store: Store,
    ) {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.addEventListener("message", (event) => {
                if (event.data?.type === "INCREMENT_NOTIFICATION") {
                    const count = NotificationCounter.increment();
                    if ("setAppBadge" in navigator) {
                        navigator.setAppBadge(count).catch((err) => console.warn("Badge failed:", err));
                    }
                }
            });
        }
    }

    register() {
        this.store.select(selectLoggedIn).subscribe((value) => {
            if (!value.isAdmin && !value.isUser) {
                this.initiated = false;
            }

            if ((value.isAdmin || value.isUser) && !this.initiated) {
                this.initiated = true;
                this._getDeviceToken();
                this._onMessage();
            }
        });
    }

    private _getDeviceToken(): void {
        getToken(this._messaging, { vapidKey: environment.VAPID_KEY })
            .then((token) => {
                if (token) {
                    console.log("FCM Token retrieved:", token);
                    this.pushNotificationAPIService.updateToken({ token }).subscribe(
                        () => console.log("Token sent to backend"),
                        (error: any) => console.error("Error sending token:", error),
                    );
                } else {
                    console.error("No FCM token retrieved.");
                }
            })
            .catch((error) => {
                console.error("FCM Token Error:", error);
                // this.messageService.add({
                //     summary: "Notification permission denied",
                //     detail: "Notification permission denied, please enable permission to receive notifications from page settings.",
                //     severity: "error",
                // });
            });
    }

    private _onMessage(): void {
        if (this._messaging) {
            onMessage(this._messaging, {
                next: (payload: any) => {
                    console.log(payload, "idhar aaya");
                    const count = NotificationCounter.increment();

                    this.messageService.add({
                        summary: payload.data?.title,
                        detail: payload.data?.message,
                        icon: "ph-info",
                        severity: "info",
                        data: payload.data,
                    });

                    if ("setAppBadge" in navigator) {
                        navigator.setAppBadge(count).catch((err) => console.warn("Badge failed:", err));
                    }
                },
                error: (error) => console.log("Message error", error),
                complete: () => console.log("Done listening to messages"),
            });
        }
    }

    isIOS() {
        const browserInfo = navigator.userAgent.toLowerCase();

        if (browserInfo.match("iphone") || browserInfo.match("ipad")) {
            return true;
        }
        if (
            ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
                navigator.platform,
            )
        ) {
            return true;
        }
        return false;
    }

    requestPermission() {
        if (this.isIOS()) {
            return;
        }
        Notification.requestPermission().then((notificationPermissions: NotificationPermission) => {
            if (notificationPermissions === "granted") {
                this._getDeviceToken();
            }
            if (notificationPermissions === "denied") {
                console.log("Denied");
                this.messageService.add({
                    summary: "Notification permission denied",
                    detail: "Notification permission denied, please enable permission to receive notifications from page settings.",
                    severity: "error",
                });
            }
        });
    }

    clearBadge() {
        NotificationCounter.clear();
        if ("clearAppBadge" in navigator) {
            navigator.clearAppBadge();
        }
    }
}
